import {
  TouchableOpacity as ReactNativeButton,
  ViewStyle,
  TextStyle,
} from 'react-native';
import React from 'react';
import {colors} from 'theme/Colors';
import {usePlatformStyles} from 'hooks';
import {Text} from 'ui-kits';
type baseStyleProp = {
  button: ViewStyle;
  text: TextStyle;
};

const BASE: baseStyleProp = {
  button: {
    width: 310,
    height: 40,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
  },
  text: {
    fontSize: 16,
    fontWeight: '600',
  },
};

type variantsType = {
  primary: baseStyleProp;
  secondary: baseStyleProp;
  outline: baseStyleProp;
  disabled: baseStyleProp;
  outlineDisabled: baseStyleProp;
};

const variants: variantsType = {
  // default
  primary: {
    button: {...BASE.button, backgroundColor: colors.palette.brandBlue},
    text: {...BASE.text, color: 'white'},
  },
  secondary: {
    button: {
      ...BASE.button,
      backgroundColor: 'white',
      borderWidth: 1.5,
      borderColor: colors.palette.brandBlue,
      borderStyle: 'solid',
    },
    text: {...BASE.text, color: colors.palette.brandBlue},
  },
  outline: {
    button: {
      ...BASE.button,
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: 'white',
    },
    text: {
      color: 'white',
    },
  },
  disabled: {
    button: {
      ...BASE.button,
      // backgroundColor: "#F4F5F7"
      backgroundColor: 'rgba(160, 160, 160, 0.4)', // better works on dark and light screen
    },
    text: {
      ...BASE.text,
      color: colors.palette.white,
    },
  },
  outlineDisabled: {
    button: {
      ...BASE.button,
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: 'rgba(255,255,255,0.6)',
    },
    text: {
      color: 'rgba(255,255,255,0.6)',
    },
  },
};

type propType = Readonly<{
  variant?: keyof typeof variants;
  text?: string;
  onPress?: () => void;
  style?: ViewStyle;
  textStyle?: TextStyle;
  disabled?: boolean;
}>;

export function Button(props: propType) {
  const {
    variant = 'primary',
    text,
    onPress,
    style: styleOverride,
    textStyle: textStyleOverride,
    disabled,
  } = props;

  const styles = disabled
    ? variants.disabled
    : variants[variant] || variants.primary;

  const webStyles = usePlatformStyles('web');

  return (
    <ReactNativeButton
      onPress={onPress}
      disabled={disabled}
      style={[styles.button, styleOverride, webStyles({outline: 'none'})]}>
      <Text style={[styles.text, textStyleOverride]}>{text}</Text>
    </ReactNativeButton>
  );
}
